import {
    CONFIRMED_CREATE_VENDOR_ACTION,
    CONFIRMED_DELETE_VENDOR_ACTION,
    CONFIRMED_EDIT_VENDOR_ACTION,
    CONFIRMED_GET_VENDORS,
    CREATE_VENDOR_ACTION,    
    CREATE_VENDOR_ERROR_ACTION,
    VENDOR_ERROR_ACTION,
    CLEAR_VENDOR_ERROR,
    LOADING_VENDORS,
    CONFIRMED_UPDATE_PLAN_STATUS_ACTION,
    CONFIRMED_GET_VENDOR  
} from '../actions/VendorTypes';

const initialState = {
    vendors: [],
    vendor: {},
    loading: false,
    createVendorError: {}
};

export default function VendorReducer(state = initialState, actions) {
    if (actions.type === CREATE_VENDOR_ACTION) { 
        return {
            ...state,
            vendors: [...state.vendors],
        };
    }

    if (actions.type === CONFIRMED_DELETE_VENDOR_ACTION) {
        const vendors = state.vendors.filter(vendor => vendor.id !== actions.payload);
        return {
            ...state,
            vendors,
        };
    }

    if (actions.type === CONFIRMED_EDIT_VENDOR_ACTION) {
        const vendors = state.vendors.map(vendor => 
            vendor.id === actions.payload.id ? actions.payload : vendor
        );
        return {
            ...state,
            vendors,
        };
    }

     if (actions.type === CONFIRMED_UPDATE_PLAN_STATUS_ACTION) {
           
           //
        }

    if (actions.type === CONFIRMED_CREATE_VENDOR_ACTION) {

        const vendors = [...state.vendors];
        
        return {
            ...state,
            vendors,
        };
       
    }

    if (actions.type === CONFIRMED_GET_VENDORS) {
        return {
            ...state,
            vendors: actions.payload,
        };
    }

    if (actions.type === CONFIRMED_GET_VENDOR) {
        return {
            ...state,
            vendor: actions.payload,
        };
    }

    if (actions.type === LOADING_VENDORS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === VENDOR_ERROR_ACTION) {
        return {
            ...state,
            createVendorError: actions.payload,
        };
    }

    if (actions.type === CLEAR_VENDOR_ERROR) {
        return {
            ...state,
            createVendorError: {},
        };
    }
  
    return state;
}
